import { productsSliderInit } from '../sliders/sliders';

/**
 * Initialize the recomendations API
 * @param  {Int} productId       The ID of a product
 * @param  {jQ Object} $container      Container of the recomendations
 * @param  {jQ Object} $productsHolder Holder for the products to populate
 * @param  {String} itemClass       Additional class for the product item
 * @return {Void}
 */
export const recommendationsInit = (productId, $container, $productsHolder, itemClass = '') => {
  $productsHolder.hasClass('slick-initialized') && $productsHolder.slick('unslick');
  $productsHolder.empty();

  $.ajax({
    url: `/recommendations/products.json?product_id=${productId}`,
    success(res) {
      const products = res.products;

      if (products != undefined && products.length) {
        let html = '';

        products.forEach((product) => {
          const isDiscontinued =
            product.tags.indexOf('DISCONTINUED|Mens') !== -1 ||
            product.tags.indexOf('DISCONTINUED|Womens') !== -1;

          if (isDiscontinued) return

          let productTitle = product.title;
          let productHtml = $('#recommendations-product-template').text();
          const imageUrl =
            product.featured_image ||
            'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_220x.gif';

          product.tags.forEach((tag) => {
            if (tag.indexOf('SHORTNAME|') != -1) {
              productTitle = tag.split('SHORTNAME|')[1];
            }
          });

          productHtml = productHtml.replace(/{{url}}/g, product.url);
          productHtml = productHtml.replace(/{{imageUrl}}/g, imageUrl);
          productHtml = productHtml.replace(/{{title}}/g, productTitle);
          productHtml = productHtml.replace(/{{price}}/g, Shopify.formatMoney(product.variants[0].price, Shopify.current_money_format));
          productHtml = productHtml.replace(/{{id}}/g, product.variants[0].id);
          productHtml = productHtml.replace(/{{class}}/g, itemClass);

          html += productHtml;
        });

        html = $(html);
        html.appendTo($productsHolder);
        $container.removeClass('hidden');
        productsSliderInit();
      }
    },
  });
};

let productId;

if ($('.js-cart-holder').length) {
  productId = $('.js-cart-holder')
    .find('[data-recommendations-product-id]')
    .eq(0)
    .data('recommendations-product-id');
}

if (productId != undefined) {
  recommendationsInit(productId, $('.js-section-related-products'), $('.js-section-related-products .js-products-holder'));
}
